(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SPEAKALIO-FCE-B-02-zawartosc"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__sfzZawartoscInit) return;
  window.__sfzZawartoscInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.speakalio-fce-b-02-zawartosc .sfz-toggle');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (open) {
      panel.hidden = true;
      panel.classList.remove('is-opening');
    } else {
      panel.hidden = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) panel.classList.add('is-opening');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-FCE-B-04-cwiczenia"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEL = '.speakalio-fce-b-04-cwiczenia';

  function init(root) {
    if (!root || root.getAttribute('data-s4-init')) return;
    root.setAttribute('data-s4-init', '1');

    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function resetAnswers() {
      [].slice.call(root.querySelectorAll('[data-s4-toggle]')).forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = btn.getAttribute('data-show');
        var ans = document.getElementById(btn.getAttribute('aria-controls'));
        if (ans) ans.hidden = true;
      });
    }

    function activate(i, focus) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      resetAnswers();
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i, false); });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); activate(next, true); }
      });
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-s4-toggle]') : null;
      if (!btn || !root.contains(btn)) return;
      var ans = document.getElementById(btn.getAttribute('aria-controls'));
      if (!ans) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      ans.hidden = open;
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.textContent = open ? btn.getAttribute('data-show') : btn.getAttribute('data-hide');
    });

    /* edytor motywu: wybór bloku otwiera jego zakładkę */
    root.addEventListener('shopify:block:select', function (e) {
      var idx = panels.indexOf(e.target);
      if (idx > -1) activate(idx, false);
    });
  }

  function initAll() {
    [].slice.call(document.querySelectorAll(SEL)).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector(SEL) : null;
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-FCE-B-06-od-czego-zaczac"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.sfb06Ready) return;
    root.dataset.sfb06Ready = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sfb06]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Edytor motywu Shopify
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-sfb06]') : null;
    if (r) init(r);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var t = document.getElementById('sfb06-tab-' + e.detail.blockId);
    if (t) t.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-FCE-B-08-pasek-sticky-mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 767px)');

    function init(bar) {
      if (!bar || bar.dataset.sfb08Ready) return;
      bar.dataset.sfb08Ready = 'true';

      var designMode = bar.dataset.designMode === 'true';
      var heroEl = null;
      var offerEl = null;
      var heroPassed = false;
      var offerInView = false;
      var observers = [];

      function q(sel) {
        if (!sel) return null;
        try { return document.querySelector(sel); } catch (e) { return null; }
      }

      function setVisible(show) {
        var active = show && mq.matches;
        bar.classList.toggle('is-visible', active);
        bar.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
        document.body.classList.toggle('sfb08-has-bar', active);
        if (active) {
          document.body.style.setProperty('--sfb08-h', bar.offsetHeight + 'px');
        }
      }

      function update() {
        if (designMode) { setVisible(true); return; }
        setVisible(heroPassed && !offerInView);
      }

      function setup() {
        observers.forEach(function (o) { o.disconnect(); });
        observers = [];

        heroEl = q(bar.dataset.heroSelector);
        offerEl = q(bar.dataset.offerSelector);

        if ('IntersectionObserver' in window) {
          if (heroEl) {
            var ho = new IntersectionObserver(function (entries) {
              entries.forEach(function (e) {
                // hero CTA zniknął nad górną krawędzią ekranu = przewinięto hero
                heroPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
              });
              update();
            });
            ho.observe(heroEl);
            observers.push(ho);
          }
          if (offerEl) {
            var oo = new IntersectionObserver(function (entries) {
              entries.forEach(function (e) { offerInView = e.isIntersecting; });
              update();
            });
            oo.observe(offerEl);
            observers.push(oo);
          }
        }

        // Fallback bez elementu hero: pokaż po przewinięciu ok. jednego ekranu
        if (!heroEl) {
          var onScroll = function () {
            heroPassed = window.scrollY > window.innerHeight * 0.8;
            update();
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
        }
        update();
      }

      if (mq.addEventListener) {
        mq.addEventListener('change', update);
      } else if (mq.addListener) {
        mq.addListener(update);
      }
      window.addEventListener('resize', function () {
        if (bar.classList.contains('is-visible')) {
          document.body.style.setProperty('--sfb08-h', bar.offsetHeight + 'px');
        }
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
      } else {
        setup();
      }
    }

    function initAll() {
      document.querySelectorAll('[data-sfb08]').forEach(init);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-FCE-B-09-oferta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT = '.speakalio-fce-b-09-oferta';
  var MAX_THUMBS = 4;

  function fmt(cents) {
    var v = cents / 100;
    var whole = Math.abs(v - Math.round(v)) < 0.001;
    return v.toLocaleString('pl-PL', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: 2
    }) + ' zł';
  }

  function plAddons(n) {
    if (n === 1) return n + ' dodatek';
    var l = n % 10, t = n % 100;
    if (l >= 2 && l <= 4 && !(t >= 12 && t <= 14)) return n + ' dodatki';
    return n + ' dodatków';
  }

  function el(root, name) { return root.querySelector('[data-el="' + name + '"]'); }

  function line(text, price, cls) {
    var d = document.createElement('div');
    d.className = 'sfb09-line' + (cls ? ' ' + cls : '');
    var s = document.createElement('span');
    s.textContent = text;
    d.appendChild(s);
    if (price != null && price !== '') {
      var b = document.createElement('b');
      b.textContent = price;
      d.appendChild(b);
    }
    return d;
  }

  function cloneThumb(inp) {
    var lab = inp.closest('label');
    var th = lab && lab.querySelector('.sfb09-thumb');
    if (!th) return null;
    var c = th.cloneNode(true);
    c.className = c.className.replace(/\bsfb09-stack-\d\b/g, '').replace(/\s+/g, ' ').trim();
    c.style.display = 'block';
    return c;
  }

  function init(root) {
    if (root.dataset.sfb09init) return;
    root.dataset.sfb09init = '1';

    var tiers = [];
    try {
      tiers = (JSON.parse(root.dataset.tiers) || []).map(function (t, i) {
        return { n: Number(t.n), p: Number(t.p), c: t.c || '', i: i };
      });
    } catch (e) {}
    tiers = tiers.filter(function (t) { return t.n > 0 && t.p > 0; })
                 .sort(function (a, b) { return a.n - b.n; });

    var modes = [].slice.call(root.querySelectorAll('.sfb09-mode input'));
    var bundleIn = root.querySelector('.sfb09-mode--bundle input');
    var paneBundle = root.querySelector('[data-pane="bundle"]');
    var paneCustom = root.querySelector('[data-pane="custom"]');
    var packs = [].slice.call(root.querySelectorAll('.sfb09-pack input'));
    var addons = [].slice.call(root.querySelectorAll('.sfb09-addon input'));
    var tierEls = [].slice.call(root.querySelectorAll('.sfb09-tier'));
    var rangeStep = el(root, 'range-step');
    var rangeBox = el(root, 'ranges');
    var rangeName = 'sfb09-range-' + Math.random().toString(36).slice(2, 8);
    var counts = packs.map(function (p) { return parseInt(p.dataset.count, 10) || 0; }).filter(function (c) { return c > 0; });
    var unit = counts.length ? Math.min.apply(null, counts) : 0;
    var total = counts.length ? Math.max.apply(null, counts) : 0;
    var nBlocks = (unit > 0 && total % unit === 0) ? total / unit : 0;
    var range = { forCount: -1, val: '', variant: '', price: 0, named: false };
    var addBtn = el(root, 'add');
    var ctaEl = el(root, 'cta-text');
    var status = el(root, 'status');
    var panel = el(root, 'panel');
    var more = el(root, 'more');
    var moreIc = el(root, 'more-ic');
    var nudgeBtn = el(root, 'nudge');
    var state = { code: '', items: [], complete: false, marker: '' };
    var ctaLabel = ctaEl.textContent;

    var maxPack = packs.slice().sort(function (a, b) {
      return (parseInt(b.dataset.count, 10) || 0) - (parseInt(a.dataset.count, 10) || 0);
    })[0] || null;

    // zapamiętaj oryginalne ceny dodatków (sformatowane przez Shopify)
    addons.forEach(function (a) {
      var p = a.closest('.sfb09-addon').querySelector('.sfb09-addon__price');
      if (p) p.dataset.orig = p.textContent;
    });

    // ---------- krok 2: które arkusze ----------
    // opcje: kolejne zakresy ciągłe o długości pakietu (5: 1–5, 6–10, 11–15; 10: 1–10, 6–15; 15: 1–15).
    // Można je nadpisać blokami „Zakres arkuszy” (osobny wariant produktu dla każdej opcji).
    var rangeData = [].slice.call(root.querySelectorAll('[data-range]'));

    function parseNums(label) {
      var out = [];
      String(label || '').split('+').forEach(function (part) {
        var m = part.match(/(\d+)\s*[–—-]\s*(\d+)/);
        if (m) { for (var n = +m[1]; n <= +m[2]; n++) out.push(n); }
        else { var one = part.match(/(\d+)/); if (one) out.push(+one[1]); }
      });
      return out;
    }

    function rangeLabel(from, len) {
      return (from * unit + 1) + '–' + ((from + len) * unit);
    }

    function selectOpt(o) {
      range.val = o ? o.label : '';
      range.variant = o ? o.variant : '';
      range.price = o ? o.price : 0;
    }

    function buildRanges(count, packInput) {
      range.forCount = count;
      range.named = false;
      selectOpt(null);
      rangeBox.textContent = '';
      var k = unit ? count / unit : 0;
      var ok = nBlocks >= 1 && k >= 1 && k <= nBlocks && Math.floor(k) === k;
      if (!ok) { rangeStep.hidden = true; return; }

      // opcje z bloków „Zakres arkuszy” dla tego pakietu; bez bloków – generowane automatycznie
      var opts = rangeData
        .filter(function (d) { return parseInt(d.dataset.count, 10) === count && d.dataset.label; })
        .map(function (d) {
          return {
            label: d.dataset.label,
            price: parseInt(d.dataset.price, 10) || 0,
            variant: d.dataset.variant || '',
            avail: d.dataset.avail !== 'false',
            nums: parseNums(d.dataset.label)
          };
        });
      if (!opts.length) {
        for (var i = 0; i + k <= nBlocks; i++) {
          var nums = [];
          for (var n = i * unit + 1; n <= (i + k) * unit; n++) nums.push(n);
          opts.push({ label: rangeLabel(i, k), price: 0, variant: '', avail: true, nums: nums });
        }
      }

      // bez wariantu z bloku zakresu: szukaj w wariantach produktu pakietu wariantu o nazwie zakresu (np. „6-15”)
      var holder = packInput ? packInput.closest('label') : null;
      var pvs = holder ? [].slice.call(holder.querySelectorAll('[data-pv]')) : [];
      function norm(t) { return String(t).replace(/[–—]/g, '-').replace(/\s+/g, '').toLowerCase(); }
      opts.forEach(function (o) {
        if (o.variant) return;
        var want = norm(o.label);
        var hit = pvs.filter(function (d) {
          return String(d.dataset.title).split('/').some(function (part) { return norm(part) === want; });
        })[0];
        if (hit) {
          o.variant = hit.dataset.variant;
          o.price = parseInt(hit.dataset.price, 10) || 0;
          o.avail = hit.dataset.avail !== 'false';
        }
      });

      var first = opts.filter(function (o) { return o.avail; })[0] || opts[0];
      selectOpt(first);
      if (opts.length === 1) { rangeStep.hidden = true; return; }
      range.named = true;
      rangeStep.hidden = false;

      var packPriceNow = packInput ? (parseInt(packInput.dataset.price, 10) || 0) : 0;
      opts.forEach(function (o) {
        var lab = document.createElement('label');
        lab.className = 'sfb09-range';
        var inp = document.createElement('input');
        inp.type = 'radio';
        inp.name = rangeName;
        inp.value = o.label;
        inp.checked = o === first;
        inp.disabled = !o.avail;
        inp.addEventListener('change', function () { selectOpt(o); recalc(); });
        var card = document.createElement('span');
        card.className = 'sfb09-range__card';
        var head = document.createElement('span');
        head.className = 'sfb09-range__head';
        var b = document.createElement('b');
        b.className = 'sfb09-range__label';
        b.textContent = o.label + (o.avail ? '' : ' · niedostępny');
        head.appendChild(b);
        if (o.price && packPriceNow && o.price !== packPriceNow) {
          var pr = document.createElement('span');
          pr.className = 'sfb09-range__price';
          pr.textContent = fmt(o.price);
          head.appendChild(pr);
        }
        var rd = document.createElement('span');
        rd.className = 'sfb09-range__radio';
        rd.setAttribute('aria-hidden', 'true');
        head.appendChild(rd);
        var strip = document.createElement('span');
        strip.className = 'sfb09-strip';
        strip.setAttribute('aria-hidden', 'true');
        var on = {};
        o.nums.forEach(function (n) { on[n] = true; });
        for (var n = 1; n <= total; n++) {
          var c = document.createElement('i');
          if (on[n]) c.className = 'on';
          c.textContent = n;
          strip.appendChild(c);
        }
        card.appendChild(head);
        card.appendChild(strip);
        lab.appendChild(inp);
        lab.appendChild(card);
        rangeBox.appendChild(lab);
      });
    }

    function currentMode() {
      var m = modes.filter(function (x) { return x.checked; })[0];
      return (m && bundleIn) ? m.value : 'custom';
    }

    function currentTier(count) {
      var best = null;
      tiers.forEach(function (t) { if (count >= t.n) best = t; });
      return best;
    }

    function setPanel(open) {
      panel.hidden = !open;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (moreIc) moreIc.textContent = open ? '▾' : '▴';
    }

    // zawartość bundle (miniatury + nazwy)
    function buildChips() {
      var box = el(root, 'chips');
      if (!box) return;
      box.textContent = '';
      (maxPack ? [maxPack] : []).concat(addons).forEach(function (inp) {
        // arkusze: link do produktu pakietu, a gdy go brak – do strony FCE Sets z ustawień sekcji
        var url = inp.dataset.url || (inp === maxPack && bundleIn ? bundleIn.dataset.sheetsUrl : '');
        var d = document.createElement(url ? 'a' : 'span');
        d.className = 'sfb09-chipi';
        if (url) { d.href = url; d.target = '_blank'; d.rel = 'noopener'; }
        var th = cloneThumb(inp);
        if (th) d.appendChild(th);
        var t = document.createElement('span');
        t.textContent = inp.dataset.name;
        d.appendChild(t);
        box.appendChild(d);
      });
    }

    // ---------- widok: CAŁY BUNDLE ----------
    function bundleView() {
      var bp = parseInt(bundleIn.dataset.price, 10) || 0;
      var items = (maxPack ? [maxPack] : []).concat(addons);
      // „cena osobno” = największy pakiet + wszystkie dodatki już z rabatem progowym (jak w koszyku)
      var tier = currentTier(addons.length);
      var pctT = tier ? tier.p : 0;
      var list = 0, known = !!maxPack && !!(parseInt(maxPack.dataset.price, 10));
      var lines = items.map(function (inp, i) {
        var p = parseInt(inp.dataset.price, 10) || 0;
        if (!p) known = false;
        var d = (i > 0 && pctT > 0) ? Math.floor(p * pctT / 100) : 0;
        list += p - d;
        return { t: inp.dataset.name, p: p ? fmt(p - d) : '', c: i === 0 ? 'sfb09-line--pack' : '' };
      });
      if (!known) list = parseInt(bundleIn.dataset.list, 10) || 0;
      var save = list > bp ? list - bp : 0;
      var pct = save ? Math.round(save * 100 / list) : 0;
      var n = parseInt(bundleIn.dataset.addons, 10) || 0;
      var sheets = parseInt(bundleIn.dataset.sheets, 10) || 0;
      var what = (sheets ? sheets + ' arkuszy' : '') + (n ? (sheets ? ' + ' : '') + plAddons(n) : '');
      return {
        title: bundleIn.dataset.name,
        hint: (save ? 'Oszczędzasz ' + fmt(save) + (what ? ' · ' : '') : '') + what,
        total: bp,
        old: save ? list : 0,
        thumbs: items,
        lines: lines,
        base: save ? list : 0,
        baseLabel: 'Cena osobno' + (pctT ? ' (z rabatem −' + pctT + '% na dodatki)' : ''),
        discLabel: 'Oszczędność w bundle (−' + pct + '%)',
        disc: save,
        panelHint: '',
        nudge: false,
        code: '',
        items: bundleIn.dataset.variant ? [{ id: parseInt(bundleIn.dataset.variant, 10), quantity: 1 }] : [],
        complete: !!bundleIn.dataset.variant,
        marker: 'FCE – cały bundle'
      };
    }

    // ---------- widok: SKOMPLETUJ ----------
    function customView() {
      var pack = packs.filter(function (p) { return p.checked && !p.disabled; })[0];
      if (!pack) {
        pack = packs.filter(function (p) { return !p.disabled; })[0];
        if (pack) pack.checked = true;
      }
      var packPrice = pack ? (parseInt(pack.dataset.price, 10) || 0) : 0;
      var packCount = pack ? (parseInt(pack.dataset.count, 10) || 0) : 0;
      if (packCount !== range.forCount) buildRanges(packCount, pack);
      if (range.price) packPrice = range.price;
      var packVariant = pack ? (range.variant || pack.dataset.variant || '') : '';
      var packName = pack ? pack.dataset.name + (range.val && range.named ? ' (' + range.val + ')' : '') : '';
      var chosen = addons.filter(function (a) { return a.checked && !a.disabled; });
      var count = chosen.length;
      var tier = currentTier(count);
      var pct = tier ? tier.p : 0;

      // rabat liczony osobno na każdej pozycji i zaokrąglany w dół (tak jak w koszyku Shopify), tylko na dodatkach
      var addonSum = 0, disc = 0;
      chosen.forEach(function (a) {
        var p = parseInt(a.dataset.price, 10) || 0;
        var d = pct > 0 ? Math.floor(p * pct / 100) : 0;
        a._d = d;
        addonSum += p;
        disc += d;
      });
      var base = packPrice + addonSum;
      var total = base - disc;

      var next = null;
      tiers.forEach(function (t) { if (!next && t.n > count) next = t; });

      var parts = [];
      if (pct > 0) {
        parts.push('−' + pct + '% na dodatki');
        parts.push('oszczędzasz ' + fmt(disc));
      }
      if (next && addons.length) {
        parts.push(count === 0
          ? 'dodaj ' + plAddons(next.n) + ' i zyskaj −' + next.p + '%'
          : 'jeszcze ' + plAddons(next.n - count) + ' = −' + next.p + '%');
      }
      var hint = parts.join(' · ');
      if (hint) hint = hint.charAt(0).toUpperCase() + hint.slice(1);

      var lines = [];
      if (pack) lines.push({ t: packName, p: packPrice ? fmt(packPrice) : '', c: 'sfb09-line--pack' });
      chosen.forEach(function (a) {
        var p = parseInt(a.dataset.price, 10) || 0;
        lines.push({ t: a.dataset.name, p: p ? fmt(p) : '', c: '' });
      });
      if (!count && addons.length) lines.push({ t: 'Bez dodatków – same arkusze', p: null, c: 'sfb09-line--muted' });

      // progi
      tierEls.forEach(function (te) {
        te.classList.toggle('is-active', !!tier && Number(te.dataset.tier) === tier.i);
      });

      // ceny przy dodatkach
      addons.forEach(function (a) {
        var card = a.closest('.sfb09-addon');
        var priceEl = card.querySelector('.sfb09-addon__price');
        var oldEl = card.querySelector('.sfb09-addon__old');
        if (!priceEl || !oldEl) return;
        var p = parseInt(a.dataset.price, 10) || 0;
        if (a.checked && !a.disabled && pct > 0 && p) {
          oldEl.hidden = false;
          oldEl.textContent = fmt(p);
          oldEl.style.textDecoration = 'line-through';
          priceEl.textContent = fmt(p - (a._d || 0));
          priceEl.classList.add('is-disc');
        } else {
          oldEl.hidden = true;
          priceEl.textContent = priceEl.dataset.orig || priceEl.textContent;
          priceEl.classList.remove('is-disc');
        }
      });

      // czy cały bundle wychodzi taniej / tak samo?
      var nudge = false, nudgeText = '';
      if (bundleIn && !bundleIn.disabled && packPrice) {
        var bp = parseInt(bundleIn.dataset.price, 10) || 0;
        if (bp > 0 && total >= bp) {
          nudge = true;
          nudgeText = (root.dataset.nudge || '').replace('{price}', fmt(bp));
        }
      }

      var shown = [];
      if (pack) shown.push(pack);
      chosen.forEach(function (a) { shown.push(a); });

      var items = [];
      if (pack && packVariant) items.push({ id: parseInt(packVariant, 10), quantity: 1 });
      chosen.forEach(function (a) {
        if (a.dataset.variant) items.push({ id: parseInt(a.dataset.variant, 10), quantity: 1 });
      });

      return {
        title: pack ? packName + (count ? ' + ' + plAddons(count) : '') : '',
        hint: hint,
        total: packPrice ? total : 0,
        old: 0,
        thumbs: shown,
        lines: lines,
        base: disc > 0 ? base : 0,
        baseLabel: 'Wartość bez rabatu',
        discLabel: 'Rabat na dodatki (−' + pct + '%)',
        disc: disc,
        panelHint: (next && addons.length)
          ? (count === 0
              ? 'Dodaj ' + plAddons(next.n) + ', a zyskasz −' + next.p + '% na dodatki.'
              : 'Dodaj jeszcze ' + plAddons(next.n - count) + ', a rabat wzrośnie do −' + next.p + '%.')
          : (pct > 0 ? 'Masz maksymalny rabat −' + pct + '% na dodatki.' : ''),
        nudge: nudge,
        nudgeText: nudgeText,
        code: tier ? tier.c : '',
        items: items,
        complete: !!pack && !!packVariant && chosen.every(function (a) { return a.dataset.variant; }),
        marker: 'FCE – własny zestaw'
      };
    }

    // ---------- rysowanie ----------
    function render(v, m) {
      el(root, 'bar-title').textContent = v.title;
      el(root, 'bar-hint').textContent = v.hint;
      el(root, 'total').textContent = v.total ? fmt(v.total) : '–';
      var oldEl = el(root, 'bar-old');
      oldEl.hidden = !v.old;
      oldEl.textContent = v.old ? fmt(v.old) : '';

      // miniatury w pasku
      var bt = el(root, 'bar-thumbs');
      bt.textContent = '';
      v.thumbs.slice(0, MAX_THUMBS).forEach(function (inp) {
        var c = cloneThumb(inp);
        if (c) bt.appendChild(c);
      });
      if (v.thumbs.length > MAX_THUMBS) {
        var mn = document.createElement('span');
        mn.className = 'sfb09-more-n';
        mn.textContent = '+' + (v.thumbs.length - MAX_THUMBS);
        bt.appendChild(mn);
      }

      // panel „Szczegóły”
      var lines = el(root, 'lines');
      lines.textContent = '';
      v.lines.forEach(function (l) { lines.appendChild(line(l.t, l.p, l.c)); });
      el(root, 'row-base').hidden = !(v.disc > 0);
      el(root, 'row-disc').hidden = !(v.disc > 0);
      el(root, 'row-save').hidden = !(v.disc > 0);
      if (v.disc > 0) {
        el(root, 'base-label').textContent = v.baseLabel;
        el(root, 'base').textContent = fmt(v.base);
        el(root, 'disc-label').textContent = v.discLabel;
        el(root, 'disc').textContent = '−' + fmt(v.disc);
        el(root, 'save').textContent = fmt(v.disc);
      }
      el(root, 'panel-hint').textContent = v.panelHint;

      // zachęta do bundle
      nudgeBtn.hidden = !v.nudge;
      nudgeBtn.textContent = v.nudge ? v.nudgeText : '';

      // przycisk
      ctaLabel = (m === 'bundle' ? root.dataset.ctaBundle : root.dataset.ctaCustom) || ctaLabel;
      if (!addBtn.hasAttribute('aria-busy')) ctaEl.textContent = ctaLabel;

      // dane do koszyka
      state.code = v.code;
      state.items = v.items;
      state.complete = v.complete;
      state.marker = v.marker;
      status.textContent = '';
    }

    function recalc() {
      var m = currentMode();
      if (paneBundle) paneBundle.hidden = (m !== 'bundle');
      paneCustom.hidden = (m !== 'custom');
      render(m === 'bundle' ? bundleView() : customView(), m);
    }

    packs.concat(addons, modes).forEach(function (i) { i.addEventListener('change', recalc); });

    nudgeBtn.addEventListener('click', function () {
      if (bundleIn && !bundleIn.disabled) {
        bundleIn.checked = true;
        recalc();
      }
    });

    // panel „Szczegóły”
    more.addEventListener('click', function (e) {
      e.stopPropagation();
      setPanel(panel.hidden);
    });
    document.addEventListener('click', function (e) {
      if (!root.isConnected || panel.hidden) return;
      if (!panel.contains(e.target) && !more.contains(e.target)) setPanel(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!root.isConnected || panel.hidden) return;
      if (e.key === 'Escape') { setPanel(false); more.focus(); }
    });

    // dodanie do koszyka
    function setBusy(busy) {
      addBtn.disabled = busy;
      if (busy) addBtn.setAttribute('aria-busy', 'true'); else addBtn.removeAttribute('aria-busy');
      ctaEl.textContent = busy ? (root.dataset.loadingText || ctaLabel) : ctaLabel;
    }

    function fail(msg) {
      setPanel(false);
      status.textContent = msg || root.dataset.errorText || 'Nie udało się dodać do koszyka.';
    }

    var didAdd = false;

    // Motion / Impulse (Archetype): zdarzenie cart:build przebudowuje szufladę, potem klik w ikonę koszyka.
    function openSideCart(data) {
      document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: data }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var openCart = document.querySelector('.js-drawer-open-cart');
      if (openCart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function () { openCart.click(); }, 200);
        return true;
      }
      var t = document.querySelector('#cart-icon-bubble, [data-cart-toggle]');
      if (t) { t.click(); return true; }
      return false;
    }

    function add() {
      status.textContent = '';
      if (!state.items.length || !state.complete) { fail(); return; }
      setBusy(true);
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      var items = state.items.map(function (it) {
        var pr = { '_zestaw': state.marker };
        if (it.props) Object.keys(it.props).forEach(function (k) { pr[k] = it.props[k]; });
        return { id: it.id, quantity: it.quantity, properties: pr };
      });
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) throw new Error(data.description || data.message || '');
            if (root.dataset.redirect === 'drawer') {
              // boczny koszyk: odśwież motyw i otwórz szufladę bez przeładowania strony
              if (openSideCart(data)) { setBusy(false); return; }
            }
            var dest = base + (root.dataset.redirect === 'checkout' ? 'checkout' : 'cart');
            didAdd = true;
            if (state.code) {
              window.location.href = base + 'discount/' + encodeURIComponent(state.code) + '?redirect=' + encodeURIComponent(dest);
            } else {
              window.location.href = dest;
            }
          });
        })
        .catch(function (err) {
          setBusy(false);
          fail(err && err.message ? err.message : '');
        });
    }

    addBtn.addEventListener('click', add);

    // powrót przyciskiem „wstecz” z koszyka/kasy: strona wraca z pamięci przeglądarki w stanie „Dodaję…”
    window.addEventListener('pageshow', function (e) {
      if (!root.isConnected) return;
      // strona wróciła z pamięci przeglądarki po dodaniu do koszyka: odśwież, żeby motyw pokazał aktualny koszyk
      if (e.persisted && didAdd) { window.location.reload(); return; }
      if (e.persisted || addBtn.hasAttribute('aria-busy')) {
        setBusy(false);
        status.textContent = '';
        recalc();
      }
    });
    buildChips();
    recalc();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(init);
  }

  function boot() { initAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-FCE-B-10-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyTopic(section, topic) {
      var items = section.querySelectorAll('[data-faq-item]');
      var firstVisible = null;
      items.forEach(function (item) {
        var match = item.getAttribute('data-topic') === topic;
        item.hidden = !match;
        if (match && !firstVisible) firstVisible = item;
      });
      section.querySelectorAll('[data-faq-topic]').forEach(function (t) {
        var active = t.getAttribute('data-faq-topic') === topic;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      return firstVisible;
    }

    function toggle(btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var icon = btn.querySelector('.speakalio-fce-b-10-faq__icon');
      if (icon) icon.textContent = open ? '×' : '+';
      panel.hidden = !open;
    }

    function init(section) {
      if (!section || section.__faqInit) return;
      section.__faqInit = true;
      var first = section.querySelector('[data-faq-topic]');
      if (!first) return;
      var firstItem = applyTopic(section, first.getAttribute('data-faq-topic'));
      if (firstItem) {
        var b = firstItem.querySelector('.speakalio-fce-b-10-faq__btn');
        if (b) toggle(b, true);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-faq-section]').forEach(init);
    }

    document.addEventListener('click', function (e) {
      var topicBtn = e.target.closest('[data-faq-topic]');
      if (topicBtn) {
        var section = topicBtn.closest('[data-faq-section]');
        var firstItem = applyTopic(section, topicBtn.getAttribute('data-faq-topic'));
        if (firstItem) {
          var b = firstItem.querySelector('.speakalio-fce-b-10-faq__btn');
          if (b && b.getAttribute('aria-expanded') !== 'true') toggle(b, true);
        }
        return;
      }
      var q = e.target.closest('.speakalio-fce-b-10-faq__btn');
      if (q) {
        toggle(q, q.getAttribute('aria-expanded') !== 'true');
      }
    });

    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('[data-faq-topic]');
      if (!tab) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[data-faq-topic]'));
      var i = tabs.indexOf(tab);
      var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var next = tabs[(i + dir + tabs.length) % tabs.length];
      e.preventDefault();
      next.focus();
      next.click();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target && e.target.querySelector ? e.target.querySelector('[data-faq-section]') : null;
      if (s) { s.__faqInit = false; init(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-MP-8-wybor-zestawu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  // Otwiera boczny koszyk (side cart) po dodaniu produktu.
  // 1) motywy typu Dawn (element <cart-drawer>): odświeża i otwiera szufladę z odpowiedzi Shopify,
  // 2) inne motywy: klika ikonę koszyka (selektor z ustawień sekcji albo typowe selektory).
  function openSideCart(root, json, drawerEl) {
    if (drawerEl && json && json.sections) {
      try { drawerEl.renderContents(json); return; } catch (err) {}
    }
    // Motion / Impulse (Archetype Themes): zdarzenie cart:build przebudowuje szufladę, potem ją otwieramy
    var archetypeOpen = document.querySelector('.js-drawer-open-cart');
    if (archetypeOpen && !root.getAttribute('data-cart-trigger')) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      setTimeout(function () { archetypeOpen.click(); }, 200);
      return;
    }
    function open() {
      var trigger = null;
      var custom = root.getAttribute('data-cart-trigger');
      try { if (custom) trigger = document.querySelector(custom); } catch (err) {}
      if (!trigger) {
        trigger = document.querySelector('#cart-icon-bubble, [data-cart-toggle], [data-drawer-open="cart"], [data-cart-drawer-toggle], header a[href$="/cart"]');
      }
      if (trigger) { trigger.click(); }
      else { window.location.href = root.getAttribute('data-cart-url'); }
    }
    // najpierw odśwież zawartość szuflady, potem ją otwórz
    refreshDrawerHtml(root, open);
  }

  // Pobiera świeżą wersję strony i podmienia zawartość szuflady koszyka,
  // żeby pokazywała dopiero co dodany produkt (dla motywów, które same się nie odświeżają).
  function refreshDrawerHtml(root, done) {
    var custom = root.getAttribute('data-cart-drawer');
    var list = custom ? [custom] : ['#CartDrawer', '#cart-drawer', '#sidebar-cart', '#SideCart', '#side-cart', '#mini-cart', '#MiniCart', '.cart-drawer', '.drawer--cart', '[data-cart-drawer]', '[id*="cart-drawer" i]', '[id*="CartDrawer"]'];
    var sel = null, el = null, i;
    for (i = 0; i < list.length; i++) {
      try { el = document.querySelector(list[i]); } catch (err) { el = null; }
      if (el) { sel = list[i]; break; }
    }
    if (!el || !window.fetch || !window.DOMParser) { done(); return; }
    fetch(window.location.pathname + '?mp_refresh=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
        if (fresh) { el.innerHTML = fresh.innerHTML; }
      })
      .catch(function () {})
      .then(done);
  }

  function init(root) {
    if (!root || root.getAttribute('data-mp-ready')) return;
    root.setAttribute('data-mp-ready', '1');
    root.classList.add('is-js');

    var tabs = qsa(root, '[role="tab"]');
    var panels = qsa(root, '.mp-card');

    function activate(index, focus) {
      if (!panels[index]) return;
      tabs.forEach(function (t, i) {
        var on = i === index;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, i) { p.classList.toggle('is-active', i === index); });
      // cała sekcja przyjmuje kolory wybranego poziomu
      root.setAttribute('data-theme', panels[index].getAttribute('data-theme') || '');
      if (focus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i, false); });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key, next = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') next = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') next = (i - 1 + n) % n;
        else if (k === 'Home') next = 0;
        else if (k === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); activate(next, true); }
      });
    });

    // ?poziom=rozszerzona otwiera dany poziom (nazwa zakładki małymi literami)
    try {
      var wanted = new URLSearchParams(window.location.search).get('poziom');
      if (wanted) {
        tabs.forEach(function (t, i) { if (t.getAttribute('data-slug') === wanted) activate(i, false); });
      }
    } catch (err) {}

    // Edytor motywu: zaznaczenie bloku przełącza poziom
    root.addEventListener('mp:select-block', function (e) {
      panels.forEach(function (p, i) { if (p.getAttribute('data-block-id') === e.detail) activate(i, false); });
    });

    qsa(root, 'form.mp-form').forEach(function (form) {
      var btn = form.querySelector('.mp-btn');
      var status = form.querySelector('.mp-status');
      var select = form.querySelector('select[name="id"]');
      var card = form.closest('.mp-card');
      var label = btn ? btn.textContent : '';

      if (select) {
        select.addEventListener('change', function () {
          var o = select.options[select.selectedIndex];
          var price = card && card.querySelector('[data-mp-price]');
          if (price && o && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
        });
      }

      function setBusy(on) {
        if (!btn) return;
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
        if (on) btn.setAttribute('disabled', 'disabled'); else btn.removeAttribute('disabled');
      }
      function say(text, isError) {
        if (!status) return;
        status.textContent = text || '';
        status.classList.toggle('is-error', !!isError);
      }

      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return; // zwykły submit jako zapas
        e.preventDefault();
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        setBusy(true);
        say('');

        var mode = root.getAttribute('data-after-add') || 'cart';
        var data = new FormData(form);
        if (!data.get('quantity')) data.append('quantity', '1');

        // motywy typu Dawn: poproś Shopify o gotowy HTML szuflady razem z odpowiedzią
        var drawerEl = null;
        if (mode === 'drawer') {
          drawerEl = document.querySelector('cart-drawer');
          if (drawerEl && typeof drawerEl.getSectionsToRender === 'function' && typeof drawerEl.renderContents === 'function') {
            data.append('sections', drawerEl.getSectionsToRender().map(function (x) { return x.id; }).join(','));
            data.append('sections_url', window.location.pathname);
          } else {
            drawerEl = null;
          }
        }

        fetch(root.getAttribute('data-cart-add-url'), {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, json: j }; });
          })
          .then(function (res) {
            if (!res.ok) { throw new Error((res.json && (res.json.description || res.json.message)) || ''); }
            document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: res.json }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (mode === 'drawer') { openSideCart(root, res.json, drawerEl); setBusy(false); return; }
            if (mode === 'cart') { window.location.href = root.getAttribute('data-cart-url'); return; }
            if (mode === 'checkout') { window.location.href = root.getAttribute('data-checkout-url'); return; }
            // zostań na stronie
            if (status) {
              status.textContent = '';
              status.classList.remove('is-error');
              status.appendChild(document.createTextNode(root.getAttribute('data-msg-added') + ' '));
              var a = document.createElement('a');
              a.href = root.getAttribute('data-cart-url');
              a.textContent = root.getAttribute('data-msg-view-cart');
              status.appendChild(a);
            }
            setBusy(false);
          })
          .catch(function (err) {
            say((err && err.message) || root.getAttribute('data-msg-error'), true);
            setBusy(false);
            if (btn && label) btn.textContent = label;
          });
      });
    });
  }

  function initAll() { qsa(document, '[data-matura-pick]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-matura-pick]') : null;
    if (r) { r.removeAttribute('data-mp-ready'); init(r); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.closest ? e.target.closest('[data-matura-pick]') : null;
    if (root) root.dispatchEvent(new CustomEvent('mp:select-block', { detail: e.target.getAttribute('data-block-id') }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-MR-8-zestawy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  // Otwiera boczny koszyk (side cart) po dodaniu produktu.
  // 1) motywy typu Dawn (element <cart-drawer>): odświeża i otwiera szufladę z odpowiedzi Shopify,
  // 2) inne motywy: klika ikonę koszyka (selektor z ustawień sekcji albo typowe selektory).
  function openSideCart(root, json, drawerEl) {
    if (drawerEl && json && json.sections) {
      try { drawerEl.renderContents(json); return; } catch (err) {}
    }
    // Motion / Impulse (Archetype Themes): zdarzenie cart:build przebudowuje szufladę, potem ją otwieramy
    var archetypeOpen = document.querySelector('.js-drawer-open-cart');
    if (archetypeOpen && !root.getAttribute('data-cart-trigger')) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      setTimeout(function () { archetypeOpen.click(); }, 200);
      return;
    }
    function open() {
      var trigger = null;
      var custom = root.getAttribute('data-cart-trigger');
      try { if (custom) trigger = document.querySelector(custom); } catch (err) {}
      if (!trigger) {
        trigger = document.querySelector('#cart-icon-bubble, [data-cart-toggle], [data-drawer-open="cart"], [data-cart-drawer-toggle], header a[href$="/cart"]');
      }
      if (trigger) { trigger.click(); }
      else { window.location.href = root.getAttribute('data-cart-url'); }
    }
    // najpierw odśwież zawartość szuflady, potem ją otwórz
    refreshDrawerHtml(root, open);
  }

  // Pobiera świeżą wersję strony i podmienia zawartość szuflady koszyka,
  // żeby pokazywała dopiero co dodany produkt (dla motywów, które same się nie odświeżają).
  function refreshDrawerHtml(root, done) {
    var custom = root.getAttribute('data-cart-drawer');
    var list = custom ? [custom] : ['#CartDrawer', '#cart-drawer', '#sidebar-cart', '#SideCart', '#side-cart', '#mini-cart', '#MiniCart', '.cart-drawer', '.drawer--cart', '[data-cart-drawer]', '[id*="cart-drawer" i]', '[id*="CartDrawer"]'];
    var sel = null, el = null, i;
    for (i = 0; i < list.length; i++) {
      try { el = document.querySelector(list[i]); } catch (err) { el = null; }
      if (el) { sel = list[i]; break; }
    }
    if (!el || !window.fetch || !window.DOMParser) { done(); return; }
    fetch(window.location.pathname + '?mp_refresh=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
        if (fresh) { el.innerHTML = fresh.innerHTML; }
      })
      .catch(function () {})
      .then(done);
  }

  function init(root) {
    if (!root || root.getAttribute('data-mp-ready')) return;
    root.setAttribute('data-mp-ready', '1');
    root.classList.add('is-js');

    var tabs = qsa(root, '[role="tab"]');
    var panels = qsa(root, '.mp-card');

    function activate(index, focus) {
      if (!panels[index]) return;
      tabs.forEach(function (t, i) {
        var on = i === index;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, i) { p.classList.toggle('is-active', i === index); });
      // cała sekcja przyjmuje kolory wybranego poziomu
      root.setAttribute('data-theme', panels[index].getAttribute('data-theme') || '');
      if (focus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i, false); });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key, next = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') next = (i + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') next = (i - 1 + n) % n;
        else if (k === 'Home') next = 0;
        else if (k === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); activate(next, true); }
      });
    });

    // ?poziom=rozszerzona otwiera dany poziom (nazwa zakładki małymi literami)
    try {
      var wanted = new URLSearchParams(window.location.search).get('poziom');
      if (wanted) {
        tabs.forEach(function (t, i) { if (t.getAttribute('data-slug') === wanted) activate(i, false); });
      }
    } catch (err) {}

    // Edytor motywu: zaznaczenie bloku przełącza poziom
    root.addEventListener('mp:select-block', function (e) {
      panels.forEach(function (p, i) { if (p.getAttribute('data-block-id') === e.detail) activate(i, false); });
    });

    qsa(root, 'form.mp-form').forEach(function (form) {
      var btn = form.querySelector('.mp-btn');
      var status = form.querySelector('.mp-status');
      var select = form.querySelector('select[name="id"]');
      var card = form.closest('.mp-card');
      var label = btn ? btn.textContent : '';

      if (select) {
        select.addEventListener('change', function () {
          var o = select.options[select.selectedIndex];
          var price = card && card.querySelector('[data-mp-price]');
          if (price && o && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
        });
      }

      function setBusy(on) {
        if (!btn) return;
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
        if (on) btn.setAttribute('disabled', 'disabled'); else btn.removeAttribute('disabled');
      }
      function say(text, isError) {
        if (!status) return;
        status.textContent = text || '';
        status.classList.toggle('is-error', !!isError);
      }

      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return; // zwykły submit jako zapas
        e.preventDefault();
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        setBusy(true);
        say('');

        var mode = root.getAttribute('data-after-add') || 'cart';
        var data = new FormData(form);
        if (!data.get('quantity')) data.append('quantity', '1');

        // motywy typu Dawn: poproś Shopify o gotowy HTML szuflady razem z odpowiedzią
        var drawerEl = null;
        if (mode === 'drawer') {
          drawerEl = document.querySelector('cart-drawer');
          if (drawerEl && typeof drawerEl.getSectionsToRender === 'function' && typeof drawerEl.renderContents === 'function') {
            data.append('sections', drawerEl.getSectionsToRender().map(function (x) { return x.id; }).join(','));
            data.append('sections_url', window.location.pathname);
          } else {
            drawerEl = null;
          }
        }

        fetch(root.getAttribute('data-cart-add-url'), {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, json: j }; });
          })
          .then(function (res) {
            if (!res.ok) { throw new Error((res.json && (res.json.description || res.json.message)) || ''); }
            document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: res.json }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (mode === 'drawer') { openSideCart(root, res.json, drawerEl); setBusy(false); return; }
            if (mode === 'cart') { window.location.href = root.getAttribute('data-cart-url'); return; }
            if (mode === 'checkout') { window.location.href = root.getAttribute('data-checkout-url'); return; }
            // zostań na stronie
            if (status) {
              status.textContent = '';
              status.classList.remove('is-error');
              status.appendChild(document.createTextNode(root.getAttribute('data-msg-added') + ' '));
              var a = document.createElement('a');
              a.href = root.getAttribute('data-cart-url');
              a.textContent = root.getAttribute('data-msg-view-cart');
              status.appendChild(a);
            }
            setBusy(false);
          })
          .catch(function (err) {
            say((err && err.message) || root.getAttribute('data-msg-error'), true);
            setBusy(false);
            if (btn && label) btn.textContent = label;
          });
      });
    });
  }

  function initAll() { qsa(document, '[data-matura-pick]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-matura-pick]') : null;
    if (r) { r.removeAttribute('data-mp-ready'); init(r); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.closest ? e.target.closest('[data-matura-pick]') : null;
    if (root) root.dispatchEvent(new CustomEvent('mp:select-block', { detail: e.target.getAttribute('data-block-id') }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-ST-02-sprobuj-sam"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__stTryInit) return;
  window.__stTryInit = true;

  function norm(x) {
    return String(x)
      .toLowerCase()
      .replace(/[\u2018\u2019\u02BC\u0060\u00B4]/g, "'")
      .replace(/[.,!?]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function accepted(root) {
    return (root.dataset.accept || '').split(/\r?\n/).map(norm).filter(Boolean);
  }

  function clearStamp(root) {
    root.querySelectorAll('.st-try__stamp').forEach(function (n) { n.remove(); });
  }

  function feedback(root, kind, msg) {
    var fb = root.querySelector('[data-st-fb]');
    if (!fb) return;
    var icon = kind === 'ok' ? '\u2713 ' : kind === 'err' ? '\u2717 ' : '';
    fb.hidden = false;
    fb.className = 'st-try__fb is-' + kind;
    fb.textContent = icon + msg;
  }

  function showSlip(root, on) {
    var s = root.querySelector('[data-st-slip]');
    if (s) s.hidden = !on;
  }

  function stamp(root) {
    clearStamp(root);
    var paper = root.querySelector('[data-st-paper]');
    if (!paper || !root.dataset.stamp) return;
    var el = document.createElement('span');
    el.className = 'st-try__stamp';
    el.textContent = root.dataset.stamp;
    paper.appendChild(el);
  }

  function check(root) {
    var input = root.querySelector('[data-st-input]');
    var v = input.value;
    if (!v.trim()) {
      clearStamp(root);
      feedback(root, 'err', root.dataset.msgEmpty || '');
      showSlip(root, false);
      return;
    }
    var list = accepted(root);
    var n = norm(v);
    // przyjmujemy też całe zdanie ("I haven't seen Tom for ages")
    var cands = [n];
    var noI = n.replace(/^i\s+/, '');
    var noEnd = n.replace(/\s+ages$/, '');
    cands.push(noI, noEnd, noI.replace(/\s+ages$/, ''));
    var ok = cands.some(function (c) { return list.indexOf(c) !== -1; });
    if (ok) {
      stamp(root);
      feedback(root, 'ok', root.dataset.msgOk || '');
    } else {
      clearStamp(root);
      // przy błędzie od razu pokazujemy poprawną odpowiedź i klucz (jak w „Pokaż odpowiedź”)
      feedback(root, 'err', (root.dataset.msgWrong || '') + ' ' + (root.dataset.msgReveal || '') + ' ' + (root.dataset.answer || ''));
    }
    showSlip(root, true);
  }

  function reveal(root) {
    clearStamp(root);
    feedback(root, 'info', (root.dataset.msgReveal || '') + ' ' + (root.dataset.answer || ''));
    showSlip(root, true);
  }

  function reset(root) {
    clearStamp(root);
    var input = root.querySelector('[data-st-input]');
    input.value = '';
    resize(input);
    var fb = root.querySelector('[data-st-fb]');
    if (fb) { fb.hidden = true; fb.textContent = ''; }
    showSlip(root, false);
    input.focus();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-st-act]');
    if (!btn) return;
    var root = btn.closest('[data-st-try]');
    if (!root) return;
    var act = btn.getAttribute('data-st-act');
    if (act === 'check') check(root);
    else if (act === 'reveal') reveal(root);
    else if (act === 'reset') reset(root);
  });

  function resize(input) {
    var field = input.closest('[data-st-field]');
    if (field) field.dataset.value = input.value || input.getAttribute('data-placeholder') || '';
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-st-input]');
    if (input) resize(input);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-st-input]');
    if (!input) return;
    var root = input.closest('[data-st-try]');
    if (root) { e.preventDefault(); check(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SPEAKALIO-ST-05-przekartkuj"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__stPrzekInit) return;
  window.__stPrzekInit = true;

  var lastFocus = null, swiped = false, sx = null, sy = 0, sTarget = null;

  /* ---------- wachlarz: pokazuje tylko strony wybranej kategorii ---------- */
  function activate(root, idx, scrollPill) {
    var pages = Array.prototype.slice.call(root.querySelectorAll('.st-przek__page'));
    var cur = null;
    pages.forEach(function (p) { if (parseInt(p.getAttribute('data-idx'), 10) === idx) cur = p; });
    if (!cur) return;
    var cat = cur.getAttribute('data-cat');
    var group = pages.filter(function (p) { return p.getAttribute('data-cat') === cat; });
    var m = group.length, ks = group.indexOf(cur);

    pages.forEach(function (p) {
      var k = group.indexOf(p);
      if (k < 0) {
        p.hidden = true;
        p.classList.remove('is-on');
        p.setAttribute('aria-pressed', 'false');
        return;
      }
      if (p.hidden) p.style.transition = 'none';
      p.hidden = false;
      /* nieparzysta liczba stron: wybrana ląduje na środku, reszta po bokach (obieg cykliczny) */
      var odd = m % 2 === 1, h = (m - 1) / 2;
      var i2 = odd ? 2 * ((((k - ks + h) % m) + m) % m - h) : k * 2 - m + 1;
      p.style.setProperty('--i2', i2);
      p.style.setProperty('--a', Math.abs(k - ks));
      p.style.setProperty('--z', 10 - Math.abs(i2));
      var on = p === cur;
      p.classList.toggle('is-on', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    void root.offsetWidth;
    pages.forEach(function (p) { p.style.transition = ''; });

    var fan = root.querySelector('.st-przek__fan');
    if (fan) fan.style.setProperty('--n', m);

    var activePill = null;
    root.querySelectorAll('.st-przek__pill').forEach(function (b) {
      var on = b.getAttribute('data-cat') === cat;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) activePill = b;
    });
    if (scrollPill && activePill) {
      var bar = activePill.parentNode;
      if (bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: activePill.offsetLeft - (bar.clientWidth - activePill.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
  }

  function stepPage(root, d) {
    var pages = Array.prototype.slice.call(root.querySelectorAll('.st-przek__page'));
    if (!pages.length) return;
    var i = 0;
    pages.forEach(function (p, n) { if (p.classList.contains('is-on')) i = n; });
    var next = pages[(i + d + pages.length) % pages.length];
    activate(root, parseInt(next.getAttribute('data-idx'), 10), true);
  }

  /* ---------- powiększenie ---------- */
  function rootFor(lb) {
    return document.querySelector('[data-st-przek][data-section-id="' + lb.getAttribute('data-section-id') + '"]');
  }
  function getLb(root) {
    return root.querySelector('[data-st-lb]') ||
      document.querySelector('[data-st-lb][data-section-id="' + root.getAttribute('data-section-id') + '"]');
  }
  function zoomPages(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.st-przek__page[data-zoom]'));
  }
  function closeLb(lb) {
    lb.hidden = true;
    document.documentElement.classList.remove('st-przek-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }
  function openLb(root, page) {
    var lb = getLb(root);
    if (!lb || !page) return;
    if (lb.parentNode !== document.body) document.body.appendChild(lb);
    var img = lb.querySelector('[data-lb-img]');
    img.src = page.getAttribute('data-zoom');
    img.alt = page.getAttribute('data-zoom-alt') || '';
    lb.querySelector('[data-lb-cap]').textContent = page.getAttribute('aria-label') || '';
    var many = zoomPages(root).length > 1;
    lb.querySelectorAll('[data-lb-prev],[data-lb-next]').forEach(function (b) { b.hidden = !many; });
    lb.setAttribute('data-cur', page.getAttribute('data-idx'));
    if (lb.hidden) {
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.documentElement.classList.add('st-przek-lock');
      var x = lb.querySelector('[data-lb-close]');
      if (x) x.focus();
    }
    activate(root, parseInt(page.getAttribute('data-idx'), 10), true);
  }
  function stepLb(root, d) {
    var lb = getLb(root);
    var list = zoomPages(root);
    if (!lb || !list.length) return;
    var cur = 0;
    list.forEach(function (p, n) { if (p.getAttribute('data-idx') === lb.getAttribute('data-cur')) cur = n; });
    openLb(root, list[(cur + d + list.length) % list.length]);
  }

  /* ---------- zdarzenia ---------- */
  document.addEventListener('click', function (e) {
    if (swiped) { swiped = false; return; }
    var lbEl = e.target.closest('[data-st-lb]');
    var root = lbEl ? rootFor(lbEl) : e.target.closest('[data-st-przek]');
    if (!root) return;

    var stepBtn = e.target.closest('[data-fan-step]');
    if (stepBtn) {
      stepPage(root, parseInt(stepBtn.getAttribute('data-fan-step'), 10));
      return;
    }
    if (e.target.closest('[data-zoom-btn]')) {
      openLb(root, root.querySelector('.st-przek__page.is-on[data-zoom]') || zoomPages(root)[0]);
      return;
    }
    if (lbEl) {
      if (e.target === lbEl || e.target.closest('[data-lb-close]')) closeLb(lbEl);
      else if (e.target.closest('[data-lb-prev]')) stepLb(root, -1);
      else if (e.target.closest('[data-lb-next]')) stepLb(root, 1);
      return;
    }
    var t = e.target.closest('[data-idx]');
    if (!t) return;
    if (t.classList.contains('st-przek__page') && t.hasAttribute('data-zoom')) {
      openLb(root, t);
      return;
    }
    activate(root, parseInt(t.getAttribute('data-idx'), 10), t.classList.contains('st-przek__pill'));
  });

  document.addEventListener('keydown', function (e) {
    var lb = document.querySelector('[data-st-lb]:not([hidden])');
    if (!lb) return;
    if (e.key === 'Escape') { e.preventDefault(); closeLb(lb); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return !b.hidden; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      return;
    }
    var root = rootFor(lb);
    if (!root) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); stepLb(root, -1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); stepLb(root, 1); }
  });

  /* przesuwanie palcem: wachlarz i okno powiększenia */
  document.addEventListener('touchstart', function (e) {
    sx = null;
    if (e.touches.length !== 1) return;
    var tg = e.target;
    if (tg.closest('.st-przek__fan') || tg.closest('.st-przek__lb-stage')) {
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      sTarget = tg;
    }
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - sx, dy = t.clientY - sy, tg = sTarget;
    sx = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
    var d = dx < 0 ? 1 : -1;
    var lbEl = tg.closest('[data-st-lb]');
    if (lbEl) {
      var r = rootFor(lbEl);
      if (r) stepLb(r, d);
    } else {
      var root = tg.closest('[data-st-przek]');
      if (root) stepPage(root, d);
    }
    swiped = true;
    setTimeout(function () { swiped = false; }, 400);
  }, { passive: true });

  /* iOS Safari: blokada powiększania gestem w oknie podglądu */
  ['gesturestart', 'gesturechange'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest('[data-st-lb]')) e.preventDefault();
    }, { passive: false });
  });

  /* edytor motywu */
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target.closest ? e.target.closest('[data-idx]') : null;
    var root = e.target.closest ? e.target.closest('[data-st-przek]') : null;
    if (t && root) activate(root, parseInt(t.getAttribute('data-idx'), 10), true);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (!id) return;
    document.querySelectorAll('[data-st-lb][data-section-id="' + id + '"]').forEach(function (n) { n.remove(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
